import "./style.css";
import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Tooltip } from "@material-ui/core";
import { defaultStyles, FileIcon } from "react-file-icon";
import { getFileExtension } from "helpers/actions/FileActions";
import { mimeTypeCompute } from "helpers/actions/FileActions";
import FileActions from "helpers/actions/FileActions";

/**
 * Display attachments in a news item with a preview
 * @param {object} props - The component props
 * @param {object} props.attachement - The attachment object containing details like name, url, and type
 * @param {object} props.style - Additional styles to apply to the attachment preview
 * @param {Array} props.actions - List of actions available for the attachment, if null, all actions will be used
 * @returns {JSX.Element} - The rendered attachment preview component
 */
const NewsAttachmentPreview = ({ attachement, style = {}, actions = [] }) => {
	let attachementType = attachement.contentType || attachement.type;
	const textRef = useRef(null);
	const [isOverflowing, setIsOverflowing] = useState(false);

	useEffect(() => {
		if (textRef.current) {
			setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
		}
	}, []);

	return (
		<Box
			style={{
				borderRadius: "5px",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "space-between",
				border: "1px solid #ccc",
				backgroundColor: "white",
				height: "100%",
				overflow: "hidden"
			}}
			sx={{ p: 1 }}
		>
			{attachementType?.includes("image") ? (
				<Box
					component="img"
					alt={attachement.name}
					src={attachement.url}
					style={{
						width: "100%",
						height: "100%",
						objectFit: "contain",
						...style
					}}
				/>
			) : (
				<Box style={style} className="file-icon-container">
					<FileIcon
						extension={getFileExtension(attachement.name).replace(".", "")}
						{...defaultStyles[getFileExtension(attachement.name).replace(".", "").toLowerCase()]}
					/>
				</Box>
			)}

			<Box
				style={{
					width: "100%",
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "space-between",
					overflow: "hidden"
				}}
			>
				<Tooltip
					title={isOverflowing ? attachement.name : ""}
					disableHoverListener={!isOverflowing}
				>
					<Typography
						variant="body2"
						component="p"
						ref={textRef}
						style={{
							opacity: 0.7,
							fontSize: "12px",
							overflow: "hidden",
							textOverflow: "ellipsis",
							whiteSpace: "nowrap",
							maxWidth: "80%"
						}}
					>
						{attachement.name}
					</Typography>
				</Tooltip>
				<Box>
					<FileActions
						attachment={{
							// Default attachment attributes
							...attachement,
							mimeType: mimeTypeCompute(attachement)
						}}
						availableActions={actions}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default NewsAttachmentPreview;
